// Client-side session store.
//
// Holds ONE piece of mutable state: which organization the UI is
// currently acting as. Persisted to localStorage so a tab refresh
// doesn't lose the user's context.
//
// This is NOT authorization. It's a convenience so every screen doesn't
// have to pass an org id around manually, and so api.ts can inject
// X-Organization-Id. The server re-validates the membership on every
// request; a user who tampered with localStorage to name an org they
// don't belong to would get an opaque 403, not access.

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface SessionState {
  activeOrganizationId: string | null;
  setActiveOrganizationId: (id: string | null) => void;
  clear: () => void;
}

export const useSessionStore = create<SessionState>()(
  persist(
    set => ({
      activeOrganizationId: null,
      setActiveOrganizationId: id => set({ activeOrganizationId: id }),
      clear: () => set({ activeOrganizationId: null }),
    }),
    {
      name: 'oracord.session.v1',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
